// Valores editables de la landing. Todo lo que figura entre [corchetes]
// es un dato a completar con información real.

export const offerConfig = {
  // Único precio vigente en toda la landing.
  launchPrice: 19990,
  // Solo se muestra tachado dentro de la tarjeta de precio.
  previousPrice: 29990,
  reservationMinutes: 10,
  // Poner en true SOLO si el checkout realmente deja de ofrecer este precio al llegar a 00:00.
  // Con true, al terminar el timer se muestra "La oferta finalizó".
  offerEndsInCheckout: false,
  guaranteeDays: 7,
  checkoutUrl: 'https://vitalidad-360-adultos-mayores.impultienda.ar/checkout',
}

export const urgencyConfig = {
  totalCupos: 15,
  // Cupos con precio de lanzamiento que quedan hoy. Editar a mano o conectar un endpoint.
  cuposDisponiblesHoy: 9,
  // Endpoint opcional que devuelve un número o { value: number } con los cupos reales.
  cuposEndpoint: null as string | null,
  // Endpoint opcional que devuelve un número o { value: number } con visitantes activos.
  activeViewersEndpoint: null as string | null,
  // Familias que lo descargaron esta semana (dato real). Si queda en null, la línea no se muestra.
  descargasEstaSemana: null as number | null,
}

export const contactConfig = {
  supportEmail: '[correo]',
  whatsappNumber: '[número]',
}

export const authorConfig = {
  name: 'Claudia Beatriz Sosa',
  role: 'Cuidadora de adultos mayores · +18 años de experiencia',
  // URL de la foto real (idealmente WebP, cuadrada). Si queda vacía, se muestran las iniciales.
  photoUrl: '',
  signature: 'Claudia',
  bio: [
    'Hace más de 18 años que acompaño a adultos mayores. Mi vocación nació cuidando a mi propia abuela y, con el tiempo, aprendí que cuidar no es solo cumplir una rutina: es escuchar, tener paciencia, estar atenta a los detalles y transmitir tranquilidad, tanto a la persona como a su familia.',
    'Con los años entendí que la experiencia por sí sola no alcanza. Por eso invertí tiempo, esfuerzo y recursos en estudiar y capacitarme de forma continua sobre cuidado, acompañamiento y actividades para personas mayores. Quise que cada propuesta tuviera sentido, fuera clara y pudiera adaptarse a la vida real de cada familia.',
    'Así nació Vitalidad 360: un sistema que reúne lo aprendido durante años de práctica y formación. Lo creé para que más personas puedan acceder a herramientas organizadas, útiles y de calidad con una inversión accesible, contemplando también la realidad económica de nuestro país.',
    'Mi propósito es que ninguna familia sienta que tiene que atravesar este camino sola.',
  ],
}

export const valueMathConfig = {
  sesionDomicilio: 35000,
  libroActividades: 38000,
}
